// extracted by mini-css-extract-plugin
export default {"link":"Privacy_link__yaGC6","modalOverlay":"Privacy_modalOverlay__shrnv","modalContent":"Privacy_modalContent__rrhWF","closeButton":"Privacy_closeButton__mEox8"};